<template>
<div>
    <v-card flat>
    <v-layout>
        <v-card-title primary-title>
            <div>
                <div class="headline">Used Technologies</div>
            </div>
        </v-card-title>
    </v-layout>
    <v-container fluid flat grid-list-xl>
        <v-layout justify-space-between row v-for="i in Math.ceil(technologies.length / 4)" v-bind:key='i' >
            <v-flex
        v-for="tech in technologies.slice((i - 1) * 4, i * 4)"
        v-bind:key="tech.id">
                <Technology v-bind:tech='tech'/>
            </v-flex>
        </v-layout>
    </v-container>
    </v-card>
</div>
</template>
<script>
import Technology from './Technology'
export default {
    name: 'Technologies',
    props: ['technologies'],
    components: {
        Technology,
    }
}
</script>
